// extracted by mini-css-extract-plugin
var _1 = "TeammateTypeLabel-module__admin--KYhbh";
var _2 = "TeammateTypeLabel-module__guest--drax0";
var _3 = "TeammateTypeLabel-module__indicator--XI3QI";
var _4 = "TeammateTypeLabel-module__label--ZgFqC";
var _5 = "TeammateTypeLabel-module__user--IBURV";
export { _1 as "admin", _2 as "guest", _3 as "indicator", _4 as "label", _5 as "user" }
